import { Reveal } from "@/components/Reveal";
import { SectionLabel } from "@/components/home/SectionLabel";
import { TESTIMONIALS } from "@/data/content";
import { Quote, Star } from "lucide-react";

export function Testimonials() {
    return (
        <section className="bg-stone2/50 border-y border-linec" data-testid="testimonials-section">
            <div className="max-w-[1240px] mx-auto px-6 lg:px-10 py-20 lg:py-24">
                <Reveal>
                    <SectionLabel className="text-terracotta">What practices say</SectionLabel>
                    <h2 className="font-heading text-4xl sm:text-5xl tracking-tight text-ink mt-4 max-w-2xl">
                        Trusted by dental teams across Texas.
                    </h2>
                </Reveal>

                <div className="mt-12 grid md:grid-cols-3 gap-6">
                    {TESTIMONIALS.map((t, i) => (
                        <Reveal key={t.name + i} delay={(i % 3) * 0.1}>
                            <div className="relative h-full rounded-2xl border border-linec bg-cream p-8 transition-transform duration-300 hover:-translate-y-1">
                                <Quote
                                    size={40}
                                    className="text-terracotta/10 absolute top-6 right-6"
                                    aria-hidden="true"
                                />
                                <div className="flex gap-0.5">
                                    {[0, 1, 2, 3, 4].map((s) => (
                                        <Star
                                            key={s}
                                            size={15}
                                            className="text-amber-400 fill-amber-400"
                                            aria-hidden="true"
                                        />
                                    ))}
                                </div>
                                <p className="text-sm lg:text-base text-ink leading-relaxed mt-5">
                                    “{t.quote}”
                                </p>
                                <div className="flex items-center gap-3 mt-7">
                                    <span className="w-10 h-10 rounded-full bg-sage text-cream font-heading text-sm flex items-center justify-center shrink-0">
                                        {t.initials}
                                    </span>
                                    <div>
                                        <div className="font-medium text-ink text-sm">{t.name}</div>
                                        <div className="text-xs text-inksoft">{t.role}</div>
                                    </div>
                                </div>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
